import { render, staticRenderFns } from "./AdminTaisykles.vue?vue&type=template&id=edb51914&scoped=true&"
import script from "./AdminTaisykles.vue?vue&type=script&lang=js&"
export * from "./AdminTaisykles.vue?vue&type=script&lang=js&"
import style0 from "./AdminTaisykles.vue?vue&type=style&index=0&id=edb51914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb51914",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VDataTable,VRow,VTab,VTabs,VTabsSlider})
